import { Route, Routes } from 'react-router-dom';
import PaymentsListView from './PaymentsListView';

export default function PaymentsView() {
  return (
    <Routes>
      <Route index element={<PaymentsListView />} />
    </Routes>
  );
}
